<template>
	<div style="background-color: white;">
		<md-dialog-alert
	      :md-active.sync="alert"
	      :md-content="msgAlert"
	      md-confirm-text="Ok" />
		<template v-for="modalidade in eventDetail.modalidades">
			<div class="event-day" style="display: none;">
				{{ modalidade.titulo }}
			</div>
			<div v-for="cotacoes in modalidade.cotacoes">
				<div class="event-championship" style="background-image: linear-gradient(#868686, #AAAAAA); height: 50px; line-height: 50px; padding-left: 5px; text-align: left; cursor: pointer;" @click="toggle(cotacoes.titulo)">
					{{ cotacoes.titulo }}
				</div>
				<div v-if="visivel(cotacoes.titulo)">
			  		<div v-for="subevento in cotacoes.subeventos" class="md-layout event-odd" style="height: 50px;line-height: 50px;margin-bottom: 5px;border-top: 1px solid #d8d8d8; padding-top: 2px !important; padding-left: 5px !important;">
		  				<div class="md-layout-item md-small-size-80">
	  						{{ subevento.nome }}
	  					</div>
		  				<div class="md-layout-item md-small-size-20 event-tb-odd" v-bind:class="verifyClass(subevento)" v-on:click="select(subevento)" style="font-size: 11pt;text-align: center; border-radius: 5px;">
	  						{{ subevento.cotacao }}
	  					</div>
		  			</div>
			  	</div>
			</div>
		</template>
	</div>
</template>
<script>

	import axios from 'axios'

	export default {
		name: 'TitanDetail',
		props: ['eventDetail', 'selected'],
		data () {
			return {
				visiveis: [],
				alert: false,
			    msgAlert: ""
			}
		},
		watch: {
			eventDetail (val) {
				this.visiveis = []
			}
		},
		methods: {
			toggle: function(titulo) {
				let add = true
				for (let i = 0; i < this.visiveis.length; i++) {
					if (this.visiveis[i] == titulo) {
						this.visiveis.splice(i, 1);
						add = false;
					}
				}

				if (add) this.visiveis.push(titulo)
			},
			visivel: function(titulo) {
				return this.visiveis.indexOf(titulo) >= 0;
			},
			verifyClass: function(subevento) {
				return {
					'odd-disabled': this.disableSubevento(subevento),
					'odd-selected': this.isSelected(subevento)
				}
			},
			disableSubevento: function(subevento){
				return subevento.cotacao <= 1
			},
			isSelected: function(subevento) {
				let isSelected = false;
				for (let i = 0; i < this.selected.length; i++) {
					if (this.selected[i].id == subevento.id) isSelected = true;
				}

				return isSelected;
			},
			select: function(subevento) {

				if (subevento.cotacao <= 1) return false;
				if (!(this.permiteAdicionar(subevento))) {
					this.msgAlert = "Não é permitido adicionar cotações ao vivo com cotações agendadas."
					this.alert = true
					return false;
				}

				let evento = {};
				evento.schedule = this.eventDetail.schedule
				evento.nome = this.eventDetail.nomeEvento
				evento.id = this.eventDetail.idEvento
				
				subevento.evento = evento

				let exists = false;
				for (let i = 0; i < this.selected.length; i++) {
					if (this.selected[i].evento.id == evento.id) {
						if (this.selected[i].id == subevento.id) this.selected.splice(i, 1);
						else {
							this.selected.splice(i, 1, subevento);
						}
						exists = true;
					}
				}

				if (!exists) {
					this.selected.push(subevento);
				}

				this.$emit('setSelecteds', this.selected)
			},
			//Impede misturar cotações ao vivo com cotações agendadas
			permiteAdicionar: function(subevento) {
				for (let i = 0; i < this.selected.length; i++) {
					if (subevento.live != this.selected[i].live) return false;
				}

				return true;
			}
		}
	}
</script>
<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #226DA7 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme
</style>



// WEBPACK FOOTER //
// src/components/TitanDetail.vue